import React from "react";
import { UnifiedMenuProvider } from "../../store/unified-menu-context";
import { UnifiedMenuView } from "./unified-menu";
import { useActiveItemPath } from "./use-active-item-path";
import { useGetFilteredMenuItems } from "./use-get-filtered-menu-items";

export const UnifiedMenuLayout = () => {
    const [expanded, setExpanded] = React.useState(false);
    const { filteredMenuItems } = useGetFilteredMenuItems();
    const { activeItemPath } = useActiveItemPath(filteredMenuItems);

    return (
        <UnifiedMenuProvider activeItemPath={activeItemPath}>
            <UnifiedMenuView
                items={filteredMenuItems}
                expanded={expanded}
                onExpand={() => setExpanded(true)}
                onCollapse={() => setExpanded(false)}
            />
        </UnifiedMenuProvider>
    );
};
